var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"evaluation-page",class:{ inApp: _vm.$root.$data.isApp || _vm.isMiniProgram }},[(!_vm.isMiniProgram)?_c('common-title',{attrs:{"titleName":"评价","zIndex":1000}}):_vm._e(),[(_vm.isAddEvaluation)?_c('addEvaluation',{attrs:{"isMiniProgram":_vm.isMiniProgram}}):_c('evaluationList')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }